/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateAssistantForm,
  UpdateAssistantForm$Outbound,
  UpdateAssistantForm$outboundSchema,
} from "../components/updateassistantform.js";

export type UpdateAssistantSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateAssistantRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateAssistantForm: UpdateAssistantForm;
};

/** @internal */
export type UpdateAssistantSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateAssistantSecurity$outboundSchema: z.ZodMiniType<
  UpdateAssistantSecurity$Outbound,
  UpdateAssistantSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateAssistantSecurityToJSON(
  updateAssistantSecurity: UpdateAssistantSecurity,
): string {
  return JSON.stringify(
    UpdateAssistantSecurity$outboundSchema.parse(updateAssistantSecurity),
  );
}

/** @internal */
export type UpdateAssistantRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateAssistantForm: UpdateAssistantForm$Outbound;
};

/** @internal */
export const UpdateAssistantRequest$outboundSchema: z.ZodMiniType<
  UpdateAssistantRequest$Outbound,
  UpdateAssistantRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateAssistantForm: UpdateAssistantForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updateAssistantForm: "UpdateAssistantForm",
    });
  }),
);

export function updateAssistantRequestToJSON(
  updateAssistantRequest: UpdateAssistantRequest,
): string {
  return JSON.stringify(
    UpdateAssistantRequest$outboundSchema.parse(updateAssistantRequest),
  );
}
